{
  "data": [
    {
      "id": 1,
      "name": "UNIVERSITETI I TIRANËS",
      "logo": "https://api.rash.al/media/Tirana.png",
      "order": 1
    },
    {
      "id": 7,
      "name": "UNIVERSITETI POLITEKNIK I TIRANËS",
      "logo": "https://api.rash.al/media/uni_politeknik_tirane-min_zP7oU1o.jpeg",
      "order": 2
    },
    {
      "id": 2,
      "name": "UNIVERSITETI I MJEKËSISË I TIRANËS",
      "logo": "https://api.rash.al/media/uni_mjeksise_tirane-min_lGnmBPU.jpeg",
      "order": 3
    },
    {
      "id": 10,
      "name": "UNIVERSITETI BUJQËSOR I TIRANËS",
      "logo": "https://api.rash.al/media/Bujqesori.png",
      "order": 4
    },
    {
      "id": 6,
      "name": "UNIVERSITETI ALEKSANDËR MOISIU DURRËS",
      "logo": "https://api.rash.al/media/Durresi.png",
      "order": 5
    },
    {
      "id": 3,
      "name": "UNIVERSITETI LUIGJ GURAKUQI SHKODËR",
      "logo": "https://api.rash.al/media/uni_shkoder-min_shzNl7G.png",
      "order": 6
    },
    {
      "id": 12,
      "name": "UNIVERSITETI ALEKSANDËR XHUVANI ELBASAN",
      "logo": "https://api.rash.al/media/uni_elbasan-min_GeAq4Ca.png",
      "order": 7
    },
    {
      "id": 11,
      "name": "UNIVERSITETI ISMAIL QEMALI VLORË",
      "logo": "https://api.rash.al/media/Vlora.png",
      "order": 8
    },
    {
      "id": 5,
      "name": "UNIVERSITETI FAN S. NOLI KORÇË",
      "logo": "https://api.rash.al/media/Kor%C3%A7a.png",
      "order": 9
    },
    {
      "id": 4,
      "name": "UNIVERSITETI EQEREM ÇABEJ GJIROKASTËR",
      "logo": "https://api.rash.al/media/Gjirokastra.png",
      "order": 10
    },
    {
      "id": 9,
      "name": "UNIVERSITETI I ARTEVE I TIRANËS",
      "logo": "https://api.rash.al/media/Artet.png",
      "order": 11
    },
    {
      "id": 8,
      "name": "UNIVERSITETI I SPORTEVE I TIRANËS",
      "logo": "https://api.rash.al/media/uni_sporte_tirane-min.jpeg",
      "order": 12
    }
  ]
}
